import type { EsProductFragment, StoreStockStatusFragment } from '#graphql-operations'

export function useReservationFormDialog() {
  const { dialog, open, close: closeDialog } = useUiDialog('reservation-form-dialog')
  const product = useState('reservationFormDialogProduct', () => null as null | EsProductFragment)
  const storeStock = useState('storeStock', () => null as null | StoreStockStatusFragment)

  const openFor = (productData: EsProductFragment, storeStockData: StoreStockStatusFragment) => {
    product.value = productData
    storeStock.value = storeStockData
    open()
  }

  const close = () => {
    closeDialog()
    product.value = null
    storeStock.value = null
  }

  return {
    ...dialog,
    product,
    storeStock,
    openFor,
    close,
  }
}
